<script setup lang="ts">
/**
 * 自定义控件容器。
 * 集成方在 <NpNode> 上传 `#widget-custom` 插槽来渲染自己的控件
 * （例如颜色选择器、字体选择器、日期选择器、图标选择器等）。
 */
import type { CustomWidget } from '../../types/widget'

const props = defineProps<{ widget: CustomWidget }>()
</script>

<template>
  <div class="np-widget np-widget--custom nodrag" :title="props.widget.hint">
    <slot :value="props.widget.value" :widget="props.widget">
      <span class="np-widget__fallback">
        {{ props.widget.component ?? 'custom' }}
      </span>
    </slot>
  </div>
</template>
